export enum JobType {
  Reminder1 = 'Reminder 1',
  Reminder2 = 'Reminder 2',
  Reminder3 = 'Reminder 3',
  Reminder4 = 'Reminder 4',
  Scheduled = 'Scheduled',
  Prescription = 'Prescription',
  Prescription2 = 'Prescription2',
  RefillPrescription = 'RefillPrescription',
  RhinoBlast = 'RhinoBlast',
  Conversation = 'Conversation',
  HipaaRequest = 'HIPAA Request',
  HipaaManualRequest = 'HIPAA Manual Request',
}
